<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
    class="detention-dialog"
    @close="back"
  >
    <div class="detention-dialog-content">
      <div class="detention-title" :style="title.style">
        {{ title.content }}
      </div>
      <ul class="giveup">
        <li  v-for="(item,index) in reasonList" :key="index" @click="giveUpAction(item.content)" :style="item.style">
          {{ item.content }}
        </li>
      </ul>
      <div class="continue STYLE_ONE" :style="continueItem.style" v-if="continueItem.content" @click="continueApply">{{continueItem.content}}</div>
    </div>
  </nd-dialog>

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'templatePopUp',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    giveUpDetail: {
      type: Array,
      default: () => ([])
    },
    questionnaire: {
      type: String,
      default: 'WITHDRAW_POP'
    }
  },
  computed: {
    title () {
      const item = this.giveUpDetail?.find(item => item.type === 'TITLE') || {}
      const style = this.renderStyle(item)
      return { content: item.content, type: item.type, style }
    },
    continueItem () {
      const item = this.giveUpDetail?.find(item => item.type === 'CONTINUE') || {}
      const style = this.renderStyle(item)
      return { content: item.content, type: item.type, style }
    },
    reasonList () {
      const _r = this.giveUpDetail?.filter(item => item.type === 'GIVEUP') || []
      return _r.map(item => {
        item.style = this.renderStyle(item)
        return item 
      })
    },  
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions('withdraw', ['questionnaireSubmit']),
    renderStyle (item) {
      return {
        fontSize: window.px2rem(item.fontSize) + 'rem',
        color: item.color,
        fontWeight: item.needBold === 'Y' ? 'bold' : 'normal'
      }
    },
    continueApply () {
      this.visible = false
    },
    async giveUpAction (cotnent) {
      const { success } = await this.questionnaireSubmit({
        questionnaire: this.questionnaire,
        value: cotnent
      })
      if (success) {
        this.visible = false
        this.backHome()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.detention-dialog {
  .detention-title {
    text-align: center;
    padding:0 38px;
    font-size: 36px;
    line-height: 50px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    padding-bottom: 34px;
    border-bottom: 1px solid #eeeeee;
    span {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 70, 51, 1);
      line-height: 50px;
    }
  }

  .giveup {
    li {
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .continue {
    border: 0px solid transparent;
    height: 120px;
    line-height: 120px;
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: @theme;
    width: 100%;
    outline: none;
    background-color: #ffffff;
    border-top: 1px solid #eeeeee;
  }
}
</style>